export default "__VITE_ASSET__I7i0iwn2__"